export enum EmailStatusType {
    NotSent = 0,
    Sending = 1,
    SendingTest = 2,
    Sent = 3,
    SentTest = 4,
    Cancelling = 5,
    Cancelled = 6,
    Accepted = 7,
    Declined = 8,
    Commence = 9
}